import _ from "lodash";
import {getUserIdForGoogleAnalytics} from "cloud-central-utils/encryption";
import {aggregatePath, trackPageView, trackEvent} from "../mrTracker";
import {history} from "../../store";
import querystring from "query-string";
import { get } from "lodash";
import { isVirtualTourEnabled } from "offline/utils";

export const trackGaBeforeLogin = () => {
    if(process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }

    const search = querystring.parse(window.location.search);
    const tagId = process.env.REACT_APP_GOOGLE_ANALYTICS_TAG;

    if(search?.redirectFrom && search.redirectFrom === "spot" && search.spotOrgId) {
        window.gtag('config', tagId, {
            'page_location': window.origin + aggregatePath({location: window.location}),
            'send_page_view': false,
            'transport_type': 'beacon'
        });

        const label = search.spotOrgId;

        trackEvent({category: "Anon", action: `RedirectFrom:${search.redirectFrom}`, label})
    }
}

export const setFullStory = authResult => {
    if (process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }
    if (process.env.REACT_APP_USE_FULLSTORY === "true" && window.FS && authResult?.idTokenPayload) {
        getUserIdForGoogleAnalytics(authResult.idTokenPayload.sub)
            .then(userId => {
                window.FS('setIdentity', {
                    uid: userId,
                    properties: {
                        "internal": authResult.idTokenPayload['http://cloud.netapp.com/internal'],
                        "isNetappDomain": get(authResult, 'idTokenPayload["http://cloud.netapp.com/user_metadata"].email', '').toLowerCase().endsWith("netapp.com")
                    }
                });
            });
    }
};

export const setGoogleAnalytics = authResult => {
    if(process.env.REACT_APP_IS_SAAS !== "true") {
        return;
    }

    const tagId = process.env.REACT_APP_GOOGLE_ANALYTICS_TAG;
    const idTokenPayload = authResult.idTokenPayload;

    if (idTokenPayload) {
        getUserIdForGoogleAnalytics(idTokenPayload.sub)
            .then(userId => {
                window.gtag('set', { 'user_id': userId });
                if (isVirtualTourEnabled()) {
                    trackEvent({
                        event_category: 'user_login',
                        action: "Console_Simulator_Login",
                        label: 'UserId',
                        value: userId
                    });
                }
            });

        //Internal account taken from auth0
        const disableGAForInternalAccounts = ['NetAppTest', 'NetAppCourse', 'NetAppDemo'];
        const idTokenPayloadInternal = idTokenPayload['http://cloud.netapp.com/internal'];
        if (disableGAForInternalAccounts.includes(idTokenPayloadInternal)) {
            console.log(`Analytics Disabled for ${idTokenPayloadInternal} Account`);
            window[`ga-disable-${tagId}`] = true;
        } else {
            window.gtag('config', tagId, {
                'page_location': window.origin + aggregatePath({location: window.location}),
                'send_page_view': false
            });
            if (idTokenPayloadInternal === 'NetApp') {
                //verified netapp email or netapp federation
                //federations: NetAppSAML || TestSamlConn || netapp-waad || azuread || BlueXP-Federation;
                window.gtag('set', 'user_properties', {internalUser: 'YES'});
            } else {
                const email = idTokenPayload.email || 
                    _.get(authResult, 'idTokenPayload["http://cloud.netapp.com/user_metadata"].email');
                if (email && email.endsWith('@netapp.com')) {
                    //unverified netapp email
                    window.gtag('set', 'user_properties', {internalUser: 'UNKNOWN'});
                }
                else {
                    window.gtag('set', 'user_properties', {internalUser: 'NO'});
                }
            }
        }
    }
};

export const setQualtricsUserValues = (userProperties) => {
    if (process.env.REACT_APP_IS_SAAS === "true" && window.QSI) {
        window.QSIdata = JSON.stringify(userProperties);
    }
};

export const setFullStoryUserValues = (userProperties) => {
    if (process.env.REACT_APP_USE_FULLSTORY === "true" && window.FS) {
        window.FS('setProperties', {
            type: 'user',
            properties: userProperties
        });
    }
};

export const setGAUserProperties = (userProperties) => {
    if (process.env.REACT_APP_IS_SAAS === "true" && window.gtag) {
        window.gtag('set', 'user_properties', userProperties);
    }
};

export const enableGAPageViewTracking = () => {
    if (process.env.REACT_APP_IS_SAAS === "true" && window.gtag) {
        history.listen((location) => {
            trackPageView({ location });
        });
    }
};
